import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

function Footer() {
  return (
    <footer className="site-footer footer-gradient">
      {/* FOOTER BLOCKES START */}
      <div className="footer-top">
        <div className="container">
          <div className="row">
            {/* COLUMNS 1 */}
            <div className="col-lg-3 col-md-6">
              <div className="sf-site-link sf-widget-link f-margin">
                <div className="aon-footer-logo">
                  <img src="/images/logo.png" alt="" />
                </div>
                {/* <div className="aon-footer-text">
                  Morbi vehicula luctus feugiat. In sapien id odio tempor
                  iaculis.
                </div>
                <ul className="aon-footer-coinfo">
                  <li>
                    <FontAwesomeIcon
                      icon={faPhone}
                      style={{
                        width: "60px",
                        height: "44px",
                        borderRadius: "var(--site-radius)",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "20px",
                        border:"none"
                      }}
                    />
                    +917575094646
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      style={{
                        width: "60px",
                        height: "44px",
                        borderRadius: "var(--site-radius)",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "20px",
                      }}
                    />
                    info@mahalaxmioilmill.com
                  </li>
                </ul> */}
              </div>
            </div>
            {/* COLUMNS 2 */}
            <div className="col-lg-6 col-md-6">
              <div className="aon-site-link aon-widget-link f-margin">
                <h4 className="aon-f-title">Pages</h4>
                <ul className="aon-widget-foo-list">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="/about">About Us</a>
                  </li>
                  <li>
                    <a href="/contact">Contact Us</a>
                  </li>
                  <li>
                    <a href="/gallary">Gallery</a>
                  </li>
                  <li>
                    <a href="/product">Products</a>
                  </li>
                   <li>
                    <a href="/product">Blogs</a>
                  </li>
                  {/* <li>
                    <a href="contact.html">Contact Page</a>
                  </li>
                  <li>
                    <a href="our-team.html">Team Member</a>
                  </li>
                  <li>
                    <a href="gallery.html">Gallery Look</a>
                  </li> */}
                </ul>
              </div>
            </div>
            {/* COLUMNS 3 */}
            <div className="col-lg-3 col-md-12">
              <div className="sf-widget-newsletter f-margin">
                <div className="aon-footer-text">
                  <h4 className="aon-f-title">Address :</h4>
                  Plot No. 20, Ayodhya Nagar Shopping, Kapadwanj Road, Dhansura
                  - 383310, Gujarat, India
                </div>
                <ul className="aon-footer-coinfo">
                  <li>
                    <i className="fa fa-phone" /> <a style={{color: 'white'}} href="tel:08045803774">+91 8045803774</a> 
                  </li>
                  <li>
                    <i className="fa fa-envelope" style={{padding:"20px"}}/> info@mahalaxmioilmill.com
                  </li>
                </ul>
                <ul className="aon-socila-icon d-flex">
                  <li>
                    <a href="javascript:void(0);">
                      <i className="feather-facebook" />
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0);">
                      <i className="feather-twitter" />
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0);">
                      <i className="feather-linkedin" />
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0);">
                      <i className="feather-instagram" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* FOOTER COPYRIGHT */}
      <div className="footer-bottom">
        <div className="container">
          <div className="aon-footer-bottom-area">
            <div className="aon-foo-copyright">
              © Copyright 2022 <span>Mahalaxmi oil mill</span> - All Rights
              Reserved.
            </div>
          </div>
        </div>
      </div>
      {/* Footer Vverlay */}
      <div className="footer-overlay" />
      {/* Footer Patter */}
      <div className="footer-patter" />
    </footer>
  );
}

export default Footer;
